document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    // animation 
    const animationItems = document.querySelectorAll('.animation-item');
    if (animationItems.length > 0) {
        function onEntry(e) {
            e.forEach(e => {
                e.isIntersecting && e.target.classList.add("animation-active")
            }
            )
        }
        let options = {
            threshold: [.5]
        }, observer = new IntersectionObserver(onEntry, options)
        for (let e of animationItems)
            observer.observe(e);
    }
    // end animation

    /* hide header */
    let scrollWidthFunc = () => {
        let scrollWidth = window.innerWidth - document.body.clientWidth;
        document.querySelector('html').style.paddingRight = scrollWidth + 'px';
        if (window.innerWidth <= 1024) {
            document.querySelector('header').style.paddingRight = scrollWidth + 'px';
        }
    }

    // scroll-top
    const scrollTop = document.querySelector('.scroll-top');
    if (scrollTop) {
        scrollTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                scrollTop.classList.remove('hidden');
            } else {
                scrollTop.classList.add('hidden');
            }
        });

        if (window.scrollY > 300) {
            scrollTop.classList.add('scroll-top--visible');
        } else {
            scrollTop.classList.add('hidden');
        }
    }



    /* burger menu */
    const burgerMenu = document.querySelector('.burger');
    if (burgerMenu) {
        const headerMobile = document.querySelector('.header__bottom');
        burgerMenu.addEventListener("click", () => {
            if (burgerMenu.classList.contains('active')) {
                document.body.classList.remove('burger-lock');
            }
            else {
                document.body.classList.add('burger-lock');
            }
            headerMobile.classList.toggle("active");
            burgerMenu.classList.toggle("active");

            document.querySelector('html').classList.toggle('burger-lock');
        });
    }
    /* end burger menu */


    /* mobile menu */
    // Функция пересчёта полной высоты (с учётом вложенных списков)
    function getFullHeight(element) {
        let clone = element.cloneNode(true);
        clone.style.maxHeight = "none";
        clone.style.height = "auto";
        clone.style.opacity = "0";
        clone.style.position = "absolute";
        clone.style.pointerEvents = "none";
        document.body.appendChild(clone);
        let height = clone.scrollHeight;
        document.body.removeChild(clone);
        return height;
    }

    const navButtons = document.querySelectorAll(".header__nav-item");
    // Первый уровень аккордеона
    navButtons.forEach(btn => {
        const sublist = btn.querySelector(".header__nav-sublist");
        const arrow = btn.querySelector(".header__nav-arrow");

        arrow?.addEventListener("click", (e) => {
            if (window.innerWidth >= 1024) return;
            if (sublist.contains(e.target)) return;

            btn.classList.toggle("active");

            if (btn.classList.contains("active")) {
                sublist.style.maxHeight = getFullHeight(sublist) + "px";
            } else {
                sublist.style.maxHeight = null;
            }
        });

        // Второй уровень аккордеона
        const arrows = sublist?.querySelectorAll(".header__nav-arrow");
        arrows?.forEach(arrow => {
            const link = arrow.previousElementSibling;
            const subsublist = arrow.nextElementSibling;

            arrow.addEventListener("click", (e) => {
                e.stopPropagation();
                arrow.classList.toggle("active");
                link.classList.toggle("active");

                if (arrow.classList.contains("active")) {
                    subsublist.style.maxHeight = subsublist.scrollHeight + "px";
                } else {
                    subsublist.style.maxHeight = null;
                }
                // пересчитать высоту родителя с учётом всех элементов
                sublist.style.maxHeight = getFullHeight(sublist) + "px";
            });
        });
    });
    /* end mobile menu */
    // Popups
    function popupClose(popupActive) {
        popupActive.classList.remove('open');
        setTimeout(() => {
            if (!popupActive.classList.contains('open')) {
                popupActive.classList.remove('active');
            }
        }, 400);
        document.body.classList.remove('lock');
        document.querySelector('html').classList.remove('lock');
        document.querySelector('header').removeAttribute('style');
        document.querySelector('html').style.paddingRight = 0;
    }
    const popupOpenBtns = document.querySelectorAll('.popup-btn');
    const popups = document.querySelectorAll('.popup');
    const originalTitlePopup2 = document.querySelector('.original-title').innerHTML;
    const closePopupBtns = document.querySelectorAll('.close-popup-btn');
    closePopupBtns.forEach(function (el) {
        el.addEventListener('click', function (e) {
            popupClose(e.target.closest('.popup'));
        });
    });
    popupOpenBtns.forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            const path = e.currentTarget.dataset.path;
            const currentPopup = document.querySelector(`[data-target="${path}"]`);
            if (currentPopup) {
                popups.forEach(function (popup) {
                    popupClose(popup);
                    popup.addEventListener('click', function (e) {
                        if (!e.target.closest('.popup__content')) {
                            popupClose(e.target.closest('.popup'));
                        }
                    });
                });
                currentPopup.classList.add('active');
                setTimeout(() => {
                    currentPopup.classList.add('open');
                }, 10);
                if (currentPopup.getAttribute('data-target') == 'popup-change') {

                    let originaTitle = currentPopup.querySelector('.original-title');
                    if (el.classList.contains('change-item__btn')) {

                        if (el.classList.contains('doctor__btn-js')) {
                            let currentItem = el.closest('.change-item');
                            let currentTitile = currentItem.querySelector('.change-item__title');
                            originaTitle.innerHTML = 'Записаться на приём к врачу: ' + currentTitile.innerHTML
                        }
                        else {
                            if (el.classList.contains('change-item__btn_current')) {
                                originaTitle.textContent = el.textContent;
                            }
                            else {
                                let currentItem = el.closest('.change-item');
                                let currentTitile = currentItem.querySelector('.change-item__title');
                                originaTitle.innerHTML = currentTitile.innerHTML
                            }
                        }
                    }
                    else {
                        originaTitle.innerHTML = originalTitlePopup2;
                    }
                }

                if (currentPopup.getAttribute('data-target') == 'popup-jobs') {
                    let currentItems = el.closest('.jobs__items')
                    let originalText = currentPopup.querySelector('.jobs__inner_original');
                    if (originalText && currentItems.querySelector('.jobs__inner')) {
                        originalText.innerHTML = currentItems.querySelector('.jobs__inner').innerHTML;
                    }
                }
                e.stopPropagation();
                scrollWidthFunc();
                document.querySelector('html').classList.add('lock');
            }
        });
    });
    // end popups
    /* yandex map */
    const map = document.querySelectorAll('#map');
    if (map.length > 0) {
        function onEntryMap(e) {
            e.forEach(e => {
                e.isIntersecting && loadMap() && initMap();
            })
        }
        let options = {
            threshold: [0.5],
        },
            observer = new IntersectionObserver(onEntryMap, options)
        for (let e of map) observer.observe(e)
    }

    function loadMap() {
        if (!document.querySelector('[src="https://api-maps.yandex.ru/2.1/?lang=ru_RU"]')) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
            script.onload = initMap;
            document.head.appendChild(script);
        } else {
            initMap();
        }
    }

    function initMap() {
        const mapPlaceholder = document.getElementById('map-placeholder');
        if (mapPlaceholder) {
            mapPlaceholder.remove();
        }

        ymaps.ready(function () {
            const myMap = new ymaps.Map('map', {
                center: [47.231129, 39.728721],
                zoom: 13,
                controls: []
            });

            const myPlacemark = new ymaps.Placemark(
                [47.231129, 39.728721],
                {
                    hintContent: 'Ростов-на-Дону, ул. Красноармейская, д. 227',
                    balloonContent: 'Ростов-на-Дону, ул. Красноармейская, д. 227'
                },
                {
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/img/icons/map.png',  //заменить на свою иконку
                    iconImageSize: [40, 40],
                    iconImageOffset: [-20, -20],
                }
            );

            myMap.geoObjects.add(myPlacemark);
            myMap.behaviors.disable(['scrollZoom']);
        });
    }
    /* end yandex map */
    /*  search */
    const inputSearch = document.querySelectorAll('input[type=search]')
    if (inputSearch.length > 0) {
        inputSearch.forEach(elem => {
            const wrapper = elem.closest('.search-wrapper')
            if (wrapper) {

                const searchResultBlock = wrapper.querySelector('.popup__search-result')
                const popularCitiesBlock = wrapper.querySelector('.popup__search')
                const noResultsMessage = searchResultBlock.querySelector('.no-results-message')

                function search() {
                    let filter = elem.value.toUpperCase()
                    let ul = wrapper.querySelectorAll('.search-list')
                    let totalResults = 0

                    ul.forEach(item => {
                        let li = item.getElementsByTagName('li')
                        for (let i = 0; i < li.length; i++) {
                            let a = li[i].querySelector('.search-name')
                            if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
                                li[i].classList.remove('none')
                                totalResults++
                                console.log('sdd');
                            } else {
                                li[i].classList.add('none')
                            }
                        }
                    })
                    noResultsMessage.classList.toggle('none', totalResults > 0);

                    if (elem.value.trim() === '') {
                        searchResultBlock.classList.add('none')
                        popularCitiesBlock.classList.remove('none')
                    } else {
                        searchResultBlock.classList.remove('none')
                        popularCitiesBlock.classList.add('none')
                    }
                }
                elem.addEventListener('input', search)

                document.addEventListener('click', (event) => {
                    if (!wrapper.contains(event.target)) {
                        searchResultBlock.classList.add('none')
                    }
                })
            }
        })
    }
    /*  end search  */
    /* navigation */
    const articleNavigation = document.querySelector(".navigation");
    if (articleNavigation) {
        const jsScrollBlockList = document.querySelectorAll(
            ".text-block h1, .text-block h2, .text-block h3, .text-block h4"
        );

        if (jsScrollBlockList.length > 0) {
            for (let i = 0; i < jsScrollBlockList.length; i += 1) {
                const jsScrollBlock = jsScrollBlockList[i];
                const titleBlock = jsScrollBlock.textContent;
                const articleNavigationList =
                    document.querySelector(".navigation__list");
                const articleNavigationItem = document.createElement("li");
                const articleNavigationLink = document.createElement("a");
                if (jsScrollBlock.tagName == "H1") {
                    articleNavigationItem.classList.add("nav-title-h1");
                }
                articleNavigationItem.classList.add("navigation__item");
                if (jsScrollBlock.tagName == "H2") {
                    articleNavigationItem.classList.add("nav-title-h2");
                } else if (jsScrollBlock.tagName == "H3") {
                    articleNavigationItem.classList.add("nav-title-h3");
                } else if (jsScrollBlock.tagName == "H4") {
                    articleNavigationItem.classList.add("nav-title-h4");
                } else if (jsScrollBlock.tagName == "H5") {
                    articleNavigationItem.classList.add("nav-title-h5");
                } else if (jsScrollBlock.tagName == "H6") {
                    articleNavigationItem.classList.add("nav-title-h6");
                }
                articleNavigationLink.classList.add("navigation__link");
                jsScrollBlock.setAttribute("id", `${i}`);
                articleNavigationLink.setAttribute("href", `$${i}`);
                articleNavigationLink.textContent = " " + titleBlock;
                articleNavigationItem.append(articleNavigationLink);
                articleNavigationList.append(articleNavigationItem);
            }
            document.querySelectorAll('a[href^="$"').forEach((link) => {
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    let href = this.getAttribute("href").substring(1);
                    const scrollTarget = document.getElementById(href);
                    const topOffset = 140;
                    const elementPosition = scrollTarget.getBoundingClientRect().top;
                    const offsetPosition = elementPosition - topOffset;
                    window.scrollBy({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                });
            });
        } else {
            if (articleNavigation.querySelector(".navigation")) {
                articleNavigation.querySelector(".navigation").remove();
            }
        }

        const headers = document.querySelectorAll('.nav-title-h2');
        const content = articleNavigation.querySelector('.accordion__content');

        headers.forEach((item, index) => {
            let nextElement = item.nextElementSibling;

            while (nextElement && !nextElement.classList.contains('nav-title-h2')) {
                nextElement.classList.toggle('close')
                nextElement = nextElement.nextElementSibling;
            }

            item.addEventListener('click', (e) => {
                let nextElement = item.nextElementSibling;
                const isActive = item.classList.toggle('active');

                while (nextElement && !nextElement.classList.contains('nav-title-h2')) {
                    nextElement.classList.toggle('close')
                    nextElement = nextElement.nextElementSibling;
                }
            });
        });
    }
    /* end navigation */
    // Основная функция фильтрации и управления элементами
    function initFilterAndHide() {
        const filterButtonsWrap = document.querySelector('.filter__buttons');
        const filterButtons = document.querySelectorAll('.filter__button');
        const filterElems = document.querySelectorAll('.filter__element');
        const hidingButton = document.querySelector('.filter__hiding-button');
        const hidingButtonsContainer = document.querySelector('.filter__hiding-buttons');
        const maxVisibleElements = 12;

        // Переменная для отслеживания состояния кнопки
        let isExpanded = false;

        // Функция фильтрации
        function applyFilter(tabId) {
            // Сбрасываем состояние при смене фильтра
            isExpanded = false;

            // Активная кнопка
            filterButtons.forEach(btn => btn.classList.remove('active'));

            document.querySelector(`.filter__button[data-tab="${tabId}"]`).classList.add('active');
            const pricWrap = document.querySelectorAll('.prices__wrap');
            const faqsWrap = document.querySelectorAll('.faqs__main');
            const articlesItemsWrap = document.querySelectorAll('.articles__items');
            // Фильтрация элементов
            let styleDisplay = 'block';
            if (pricWrap.length > 0) {
                styleDisplay = 'contents';
            } else if (faqsWrap.length > 0) {
                styleDisplay = 'block';
            } else if (articlesItemsWrap.length > 0) {
                styleDisplay = 'flex';
            }
            filterElems.forEach(el => {
                if (tabId === '0' || el.getAttribute('data-tab') === tabId) {
                    el.style.display = styleDisplay;
                    el.classList.add('active');
                } else {
                    el.style.display = 'none';
                    el.classList.remove('active');
                }
            });

            checkHide();
        }

        // Проверка и скрытие
        function checkHide() {
            const cardsContainer = document.querySelector('.reviews__cards') || document.querySelector('.services__cards') || document.querySelector('.articles__items');
            if (!cardsContainer || !hidingButtonsContainer) return;

            const visible = Array.from(cardsContainer.querySelectorAll('.filter__element'))
                .filter(el => window.getComputedStyle(el).display !== 'none');

            // Если кнопка уже была нажата (показаны все), ничего не меняем
            if (isExpanded) {
                hidingButtonsContainer.classList.add('active');
                hidingButton.textContent = 'Скрыть';
                return;
            }
            console.log('ffff')
            visible.forEach(el => el.classList.remove('hide'));
            console.log('555')
            if (visible.length > maxVisibleElements) {
                for (let i = maxVisibleElements; i < visible.length; i++) {
                    visible[i].classList.add('hide');
                }
                hidingButtonsContainer.classList.add('active');
                hidingButton.textContent = 'Смотреть еще';
            } else {
                hidingButtonsContainer.classList.remove('active');
            }
        }

        // События
        filterButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                applyFilter(btn.getAttribute('data-tab'));
                filterButtonsWrap.classList.toggle('active');
            });
        });

        if (hidingButton) {
            hidingButton.addEventListener('click', () => {
                const activeBtn = document.querySelector('.filter__button.active');
                const tabId = activeBtn ? activeBtn.getAttribute('data-tab') : '0';
                const selector = tabId === '0' ? '.filter__element' :
                    `.filter__element[data-tab="${tabId}"]`;

                const elements = document.querySelectorAll(selector);

                if (!isExpanded) {
                    // Показываем все элементы
                    elements.forEach(el => el.classList.remove('hide'));
                    isExpanded = true;
                    hidingButton.textContent = 'Скрыть';
                } else {
                    // Скрываем лишние элементы
                    const cardsContainer = document.querySelector('.reviews__cards') || document.querySelector('.services__cards') || document.querySelector('.articles__items');

                    if (cardsContainer) {
                        const visibleElements = Array.from(cardsContainer.querySelectorAll('.filter__element'))
                            .filter(el => window.getComputedStyle(el).display !== 'none');

                        if (visibleElements.length > maxVisibleElements) {
                            for (let i = maxVisibleElements; i < visibleElements.length; i++) {
                                visibleElements[i].classList.add('hide');
                            }
                        }
                    }

                    isExpanded = false;
                    hidingButton.textContent = 'Смотреть еще';
                }
            });
        }

        // Инициализация
        const defaultActive = document.querySelector('.filter__button.active');
        if (defaultActive) applyFilter(defaultActive.getAttribute('data-tab'));
        else if (filterButtons.length > 0) applyFilter(filterButtons[0].getAttribute('data-tab'));
    }

    // Запуск
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFilterAndHide);
    } else {
        initFilterAndHide();
    }

    const openingElement = document.querySelectorAll('.opening-element');
    if (openingElement.length) {
        openingElement.forEach(element => {

            const openingElementBtn = element.querySelector('.opening-element__btn')
            const openingElementContent = element.querySelector('.opening-element__content')

            if (openingElementBtn) {

                openingElementBtn.addEventListener('click', function (e) {
                    element.classList.toggle('open');

                    if (element.classList.contains('open') && openingElementContent) {
                        const scrollHeight = openingElementContent.scrollHeight;
                        openingElementContent.style.maxHeight = scrollHeight + 'px';
                    }
                    if (!element.classList.contains('open') && openingElementContent) {
                        openingElementContent.style.maxHeight = 0;
                    }
                })
            }
        });
    }
    var swiper1 = new Swiper('.slider-docrors__swiper', {
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },


        breakpoints: {
            320: { slidesPerView: 1.2 },
            500: { slidesPerView: 1 },
            1800: { slidesPerView: 2 },
        },
        spaceBetween: 10,
    });
})

// calculator.js
document.addEventListener('DOMContentLoaded', function () {
    const calculatorConfig = {
        steps: [
            {
                title: 'Выберите услугу',
                useExisting: true,
                svgIndex: 1
            },
            {
                title: 'Место оказания помощи',
                items: [
                    { id: 'place_1', text: 'На дому', value: '' },
                    { id: 'place_2', text: 'В стационаре', value: '' },
                ],
                svgIndex: 2
            },
            {
                title: 'Срочность вызова',
                items: [
                    { id: 'urgency_1', text: 'Стандартный', value: '' },
                    { id: 'urgency_2', text: 'Срочный (до 40 мин)', value: '' },
                    { id: 'urgency_3', text: 'Экстренный (до 20 мин)', value: '' }
                ],
                svgIndex: 3
            },
            {
                title: 'Состояние пациента',
                items: [
                    { id: 'state_1', text: 'Легкое (тревожность, тремор)', value: '' },
                    { id: 'state_2', text: 'Среднее (рвота, давление)', value: '' },
                    { id: 'state_3', text: 'Тяжелое (судороги, галлюцинации)', value: '' },
                    { id: 'state_4', text: 'Критическое (потеря сознания)', value: '' }
                ],
                svgIndex: 4
            },
            {
                title: 'Дополнительные опции',
                items: [
                    { id: 'options_1', text: 'Первичная консультация врача', value: '' },
                    { id: 'options_2', text: 'Экспресс-анализы и диагностика', value: '' },
                    { id: 'options_3', text: 'Работа с психологом', value: '' },
                    { id: 'options_4', text: 'Консультация для родственников', value: '' },
                    { id: 'options_5', text: 'Лекарства на 3-5 дней', value: '' }
                ],
                svgIndex: 5
            }
        ],


        prices: [
            '9 400 ₽',
            '12 500 ₽',
            '7 800 ₽',
            '15 200 ₽',
            '11 000 ₽'
        ],

        resultTitles: {
            'Вывод из запоя': 'Вывод из запоя на дому',
            'Кодирование': 'Кодирование в клинике',
            'Лечение зависимостей': 'Лечение зависимостей',
            'Снятие ломки': 'Снятие ломки в стационаре',
            'Психотерапия': 'Психотерапия с диагностикой',
            'Реабилитация': 'Реабилитация в центре'
        }
    };

    let currentStep = 0;
    let firstSelectedCategory = '';
    let selectedServices = [];

    const calculatorChoice = document.querySelector('.calculator__choice');
    const calculatorMain = document.querySelector('.calculator__main');
    const calculatorWrap = document.querySelector('.calculator__wrap');
    const resultSection = document.querySelector('.calculator__result');
    const calculatorImage = document.querySelector('.calculator__image');
    const svgElementMob = document.querySelector('.calculator__image-mob svg');

    if (!calculatorChoice || !calculatorMain || !calculatorWrap || !resultSection || !calculatorImage || !svgElementMob) {
        return;
    }

    const choiceTitle = calculatorChoice.querySelector('.calculator__choice-title p');
    const choiceItems = calculatorChoice.querySelector('.calculator__choice-items');
    const nextBtn = calculatorChoice.querySelector('.calculator__choice-btn');
    const resultPrice = document.querySelector('.calculator__result-price p');
    const resultCategory = document.querySelector('.calculator__result-ctegory p');
    const svgElement = calculatorImage.querySelector('svg');

    if (!choiceTitle || !choiceItems || !nextBtn || !resultPrice || !resultCategory || !svgElement) {
        return;
    }

    const gElementsPath = svgElementMob.querySelectorAll('path[opacity]');
    const gElements = svgElement.querySelectorAll('g[opacity]');
    function initCalculator() {
        resultSection.style.display = 'none';

        resetSVGState();

        setupFirstStep();
        updateNextButton();
        updateSVGState();
    }

    function resetSVGState() {
        gElements.forEach(g => {
            g.setAttribute('opacity', '0.5');
        });
        gElementsPath.forEach(g => {
            g.setAttribute('opacity', '0.5');
        });
    }

    function updateSVGState() {
        for (let i = 0; i <= currentStep; i++) {
            if (gElements[i]) {
                gElements[i].setAttribute('opacity', '1');
            }
        }
        for (let i = 0; i <= currentStep; i++) {
            if (gElementsPath[i]) {
                gElementsPath[i].setAttribute('opacity', '1');
            }
        }
    }

    function setupFirstStep() {
        const firstStepItems = choiceItems.querySelectorAll('.calculator__choice-item');

        firstStepItems.forEach(item => {
            item.addEventListener('click', () => {
                if (firstSelectedCategory === '') {
                    firstSelectedCategory = item.querySelector('p').textContent;
                }
                firstStepItems.forEach(el => {
                    el.classList.remove('active');
                });

                item.classList.add('active');

                selectedServices[0] = item.querySelector('p').textContent;
                updateNextButton();
                updateSVGState();
            });
        });
    }
    function loadStep(stepIndex) {
        const step = calculatorConfig.steps[stepIndex];

        choiceTitle.textContent = step.title;

        choiceItems.innerHTML = '';

        step.items.forEach(item => {
            const choiceItem = document.createElement('div');
            choiceItem.className = 'calculator__choice-item';
            choiceItem.dataset.id = item.id;
            choiceItem.dataset.value = item.value;

            const text = document.createElement('p');
            text.textContent = item.text;

            const span = document.createElement('span');

            choiceItem.appendChild(text);
            choiceItem.appendChild(span);

            choiceItem.addEventListener('click', () => {
                document.querySelectorAll('.calculator__choice-item').forEach(el => {
                    el.classList.remove('active');
                });

                choiceItem.classList.add('active');
                selectedServices[stepIndex] = item.text;

                updateNextButton();
                updateSVGState();
            });

            choiceItems.appendChild(choiceItem);
        });
    }

    function updateNextButton() {
        if (currentStep < calculatorConfig.steps.length - 1) {
            const hasSelection = document.querySelector('.calculator__choice-item.active') !== null;

            if (hasSelection) {
                nextBtn.disabled = false;
                nextBtn.style.opacity = '1';
                nextBtn.style.cursor = 'pointer';
            } else {
                nextBtn.disabled = true;
                nextBtn.style.opacity = '0.5';
                nextBtn.style.cursor = 'not-allowed';
            }
        } else {
            nextBtn.querySelector('p').textContent = 'Рассчитать';
        }
    }

    function showResult() {
        calculatorChoice.style.display = 'none';

        calculatorMain.style.padding = '0';
        calculatorWrap.style.padding = '50px 0px';
        calculatorImage.style.display = 'none';
        svgElementMob.style.display = 'none';
        resultSection.style.display = 'block';

        gElements.forEach(g => {
            g.setAttribute('opacity', '1');
        });

        const randomPrice = calculatorConfig.prices[Math.floor(Math.random() * calculatorConfig.prices.length)];
        resultPrice.textContent = randomPrice;

        if (firstSelectedCategory && calculatorConfig.resultTitles[firstSelectedCategory]) {
            resultCategory.textContent = calculatorConfig.resultTitles[firstSelectedCategory];
        } else {
            resultCategory.textContent = calculatorConfig.resultTitles['Вывод из запоя'];
        }
    }

    nextBtn.addEventListener('click', function () {
        if (currentStep < calculatorConfig.steps.length - 1) {

            currentStep++;

            if (calculatorConfig.steps[currentStep].useExisting) {
                setupFirstStep();
            } else {
                loadStep(currentStep);
            }

            selectedServices[currentStep] = '';
            updateNextButton();

            updateSVGState();
        } else {
            showResult();
        }
    });
    initCalculator();
});
// end calculator
document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.hiding__item');
    const button = document.querySelector('.hiding__button');
    const buttonContainer = document.querySelector('.hiding__buttons');

    if (!items.length || !button || !buttonContainer) return;

    const step = 12;
    let visibleCount = 0;
    function showItems(count) {
        const toShow = Math.min(count, items.length);

        for (let i = 0; i < items.length; i++) {
            if (i < toShow) {
                items[i].classList.add('active');
            } else {
                items[i].classList.remove('active');
            }
        }

        visibleCount = toShow;
        updateButton();
    }

    function showMore() {
        const nextCount = visibleCount + step;

        for (let i = visibleCount; i < nextCount && i < items.length; i++) {
            items[i].classList.add('active');
        }

        visibleCount = Math.min(nextCount, items.length);
        updateButton();
    }

    function showLess() {
        for (let i = 0; i < items.length; i++) {
            if (i < step) {
                items[i].classList.add('active');
            } else {
                items[i].classList.remove('active');
            }
        }

        visibleCount = Math.min(step, items.length);
        updateButton();
    }

    function updateButton() {
        if (items.length > step) {
            buttonContainer.classList.add('active');
            if (visibleCount >= items.length) {
                button.textContent = 'Скрыть';
            } else {
                button.textContent = 'Показать еще';
            }
        } else {
            buttonContainer.classList.remove('active');
        }
    }

    function handleButtonClick() {
        if (visibleCount >= items.length) {
            showLess();
        } else {
            showMore();
        }
    }
    showItems(step);
    button.addEventListener('click', handleButtonClick);
});